import {Component, inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {Subscription} from 'rxjs';
import {AuthService} from '../../../services/auth-service';
import {PasswordValidationDirective} from '../../../validation/directives/password-validation-directive';

@Component({
  selector: 'app-reset-password-component',
  imports: [
    FormsModule,
    RouterLink,
    PasswordValidationDirective
  ],
  templateUrl: './reset-password-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reset-password-component.scss'
})
export class ResetPasswordComponent implements OnDestroy {

  private subscription: Subscription | null = null;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  error: string | undefined;
  successMessage: string | undefined;
  loading = false;

  email = '';
  password = '';
  confirmation = '';

  readonly token: string;

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);

  constructor() {
    this.token = (this.route.snapshot.paramMap.get('token') ?? '').trim();
  }

  get tokenMissing(): boolean {
    return this.token.length === 0;
  }

  get passwordsMismatch(): boolean {
    return this.confirmation.length > 0 && this.password !== this.confirmation;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
    }
  }

  save(form: NgForm) {
    this.error = undefined;
    if (form.valid && !this.passwordsMismatch && !this.tokenMissing && !this.loading) {
      this.loading = true;
      this.subscription = this.authService.resetPassword(this.email, this.token, this.password, this.confirmation)
        .subscribe(result => {
          if (result.data) {
            this.successMessage = 'Пароль изменён. Вы будете перенаправлены на страницу входа.';
            this.timeoutId = setTimeout(() => {
              this.router.navigate(['/login']);
            }, 3000);
          } else {
            this.error = result.error;
            this.loading = false;
          }
        });
    }
  }
}
